import React, { useState, useEffect } from "react";
import { Textfit } from "react-textfit";
import { useCustomT } from "../../hooks/useCustomT";
import styles from "./QuestionPanel.module.css";

import QuestionPanelImage from "../../images/question-panel.png";

function QuestionPanel({ questionText }) {
  const [rerenderValue, setRerenderValue] = useState(0);

  const customT = useCustomT();

  // A trick to make Textfit works accurate
  const forceRerender = () => {
    setRerenderValue((oldValue) => oldValue + 1);
  };

  useEffect(() => {
    setTimeout(forceRerender, 50);
  }, [questionText]);

  return (
    <div className={styles.questionPanel}>
      {rerenderValue && (
        <div
          className="hidden"
          style={{
            visibility: "hidden",
            width: 0,
            height: 0,
            overflow: "hidden",
          }}
          id={rerenderValue}
        />
      )}
      <img
        src={QuestionPanelImage}
        alt="question panel"
        className={styles.questionPanelImg}
      />
      <Textfit min={32} max={76} className={styles.questionPanelText}>
        <p>{customT(questionText)}</p>
      </Textfit>
    </div>
  );
}

export default React.memo(QuestionPanel);
